import { render, staticRenderFns } from "./matchNew.vue?vue&type=template&id=76185cde&scoped=true&"
import script from "./matchNew.vue?vue&type=script&lang=js&"
export * from "./matchNew.vue?vue&type=script&lang=js&"
import style0 from "./matchNew.vue?vue&type=style&index=0&id=76185cde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76185cde",
  null
  
)

export default component.exports